import { useQuery } from "@tanstack/react-query";
import api from "./api";

export const SAN = { giorni_ricetta: 6, ore_correzione: 24, giorni_prolungato: 7, giorni_dash_visite: 7, terapie_senza_visita: false };

export function useCfgSanitarie() {
  const { data } = useQuery({
    queryKey: ["cfg-sanitarie"],
    staleTime: 300000,
    queryFn: async () => { try { return (await api.get("/impostazioni/sanitarie")).data; } catch { return null; } },
  });
  if (data) Object.assign(SAN, data);
  return SAN;
}
